import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { computed, onMounted, ref, watch } from 'vue'

import { EvTripExtended } from '@/models/evTrip'

import { formatDateWithTime } from '@/helpers/date'
import { RbacAction, RbacEntity } from '@/helpers/rbac'

import { getTripLogs, createTripLog } from '@/api/ev-trips'

import useScopeCheck from '@/composables/useScopeCheck'

import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TripLogsTab',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const comment = ref('')

const allowedEditing = useScopeCheck(RbacAction.UPDATE, RbacEntity.TRIPS)

const list = ref<any[]>([])
const error = ref<string | null>(null)
const isLoading = ref(false)
const isInitialLoadingDone = ref(false)
const isCreatingComment = ref(false)
const isCreationSuccess = ref(false)

watch(isCreationSuccess, newValue => {
  if (newValue) comment.value = ''
})

const addComment = async () => {
  if (!comment.value.trim()) return

  try {
    isCreatingComment.value = true

    const response = await createTripLog(props.trip.id, comment.value)

    const newLog = response.data.data
    list.value.unshift(newLog)
    comment.value = ''
    isCreationSuccess.value = true
  } catch (error) {
    console.error('Failed to add comment:', error)
  } finally {
    isCreatingComment.value = false
  }
}

const getTripLogsData = async () => {
  try {
    isLoading.value = true
    error.value = null

    const response = await getTripLogs(props.trip.id)
    list.value = (response.data.data || []).sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )
    isInitialLoadingDone.value = true
  } catch (err) {
    console.error('Failed to load trip logs:', err)
    error.value = 'Failed to load trip logs'
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  if (!isInitialLoadingDone.value && !isLoading.value) {
    getTripLogsData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (error.value)
    ? (_openBlock(), _createBlock(CommonError, {
        key: 0,
        errorMessage: error.value,
        onRetryPress: getTripLogsData
      }, null, 8, ["errorMessage"]))
    : (!isInitialLoadingDone.value || (isLoading.value && !list.value.length))
      ? (_openBlock(), _createBlock(Loader, { key: 1 }))
      : (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 2,
          always: ""
        }, {
          default: _withCtx(() => [
            (_unref(allowedEditing))
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  class: "form-container"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "title" }, "Add comment", -1)),
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 4 },
                          placeholder: "Enter the comment",
                          resize: "vertical",
                          disabled: isCreatingComment.value,
                          modelValue: comment.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _createVNode(_component_el_button, {
                          plain: "",
                          size: "small",
                          type: "primary",
                          class: "add-btn",
                          disabled: !comment.value,
                          loading: isCreatingComment.value,
                          onClick: addComment
                        }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode(" Add comment ")
                          ])),
                          _: 1,
                          __: [1]
                        }, 8, ["disabled", "loading"])
                      ]),
                      _: 1,
                      __: [2]
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "title" }, "Logs", -1)),
                    _createVNode(_component_el_timeline, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (tripLog) => {
                          return (_openBlock(), _createBlock(_component_el_timeline_item, {
                            placement: "top",
                            size: "large",
                            key: tripLog.id,
                            timestamp: 
              _unref(formatDateWithTime)(tripLog.created_at, 'yyyy-MM-dd, HH:mm:ss')
            
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tripLog.comment), 1)
                            ]),
                            _: 2
                          }, 1032, ["timestamp"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1,
                  __: [3]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}
}

})